import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import ServicesOverview from './pages/ServicesOverview';
import ServiceWater from './pages/ServiceWater';
import ServiceSewer from './pages/ServiceSewer';
import ServicePaving from './pages/ServicePaving';
import ServiceWinter from './pages/ServiceWinter';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900 selection:bg-emerald-200 selection:text-emerald-900">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/* Services routes */}
          <Route path="/ydelser" element={<ServicesOverview />} />
          <Route path="/hvad-laver-vi" element={<ServicesOverview />} />
          <Route path="/ydelser/vandvaerksservice-ledningsarbejde" element={<ServiceWater />} />
          <Route path="/ydelser/kloakarbejde-tilslutning" element={<ServiceSewer />} />
          <Route path="/ydelser/belaegning-anlaeg" element={<ServicePaving />} />
          <Route path="/ydelser/vinterservice-snerydning" element={<ServiceWinter />} />

          {/* Gallery */}
          <Route path="/galleri" element={<Gallery />} />

          {/* About */}
          <Route path="/om-os" element={<About />} />

          {/* Contact */}
          <Route path="/kontakt-os" element={<Contact />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* Status code pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
